import React, { useMemo } from 'react';

import { EPaymentMethod, type ShoppingDelivery } from 'v2/interfaces/shopping';

interface PaymentTypeImgProps {
  delivery: ShoppingDelivery;
}

interface IPaymentType {
  img: string;
  title: string;
}

const creditCardPaymentsId = [
  EPaymentMethod.ELO,
  EPaymentMethod.ELO_2,
  EPaymentMethod.HIPERCARD,
  EPaymentMethod.HIPER,
  EPaymentMethod.VISA,
  EPaymentMethod.VISA_ELECTRON,
  EPaymentMethod.MASTERCARD,
  EPaymentMethod.DINERS,
  EPaymentMethod.DISCOVER,
  EPaymentMethod.VISA_2,
  EPaymentMethod.MASTERCARD_2
];

const getPaymentIconAssetName = (paymentId: number) => {
  if (creditCardPaymentsId.includes(paymentId)) return 'Credito';
  if (paymentId === EPaymentMethod.BOLETO) return 'Boleto';
  if (paymentId === EPaymentMethod.PAYPAL) return 'Paypal';
  if (paymentId === EPaymentMethod.PAYPAL_INTERNACIONAL) return 'Paypal Internacional';
  if (paymentId === EPaymentMethod.PIX) return 'Pix';
  if (paymentId === EPaymentMethod.PIX_AUTOMATICO) return 'Pix Automático';
  if (paymentId === EPaymentMethod.SALDO_EDUZZ) return 'Saldo Eduzz';
  if (paymentId === EPaymentMethod.PAGAMENTO_COMBINADO) return 'Pagamento Combinado';
  if (paymentId === EPaymentMethod.MULTIPLOS_CARTOES) return 'Múltiplos Cartões';
  if (paymentId === EPaymentMethod.BOLETO_PARCELADO) return 'Boleto Parcelado';

  return 'Desconhecido';
};

const getPaymentName = (paymentMethodName: string) => {
  if (!!paymentMethodName) return paymentMethodName;
  return 'Desconhecido';
};

const PaymentTypeImg = ({ delivery }: PaymentTypeImgProps) => {
  const paymentType: IPaymentType = useMemo(() => {
    return {
      img: `/img/brands/payment/${getPaymentIconAssetName(delivery.payment_method.id)}.svg`,
      title: getPaymentName(delivery.payment_method.name)
    };
  }, [delivery]);

  return (
    <img
      className={delivery.payment_method.id === EPaymentMethod.BOLETO_PARCELADO ? 'w-7' : 'w-4'}
      alt={paymentType.title}
      title={paymentType.title}
      src={paymentType.img}
    />
  );
};

export default PaymentTypeImg;
